'use client';

import { convertSecondsToMinOrHours } from '@/lib/utils';
import R2Image from '../custom-image/r2Image';
import CoinAndLevelUp from '../level-up/coin-levelup';
import { DMLink } from '../link';
import GlowRibbon from '../ribbon/GlowRibbon';

type Course = {
  id: number;
  title: string;
  slug: string;
  thumbnailImage: string;
  price: number;
  offerPrice: number;
  discountPercentage: number;
  coin: number;
  point: number;
  chapters?: string;
  description: string | null;
  category: string | null;
  duration: number | null;
  created_at: Date;
  update_at?: Date;
  comingSoon?: boolean;
};

export const CoursesCard = ({ courseList }: { courseList: Course[] }) => {
  return (
    <div className='grid max-sm:max-w-[400px] sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center max-sm:w-full max-sm:m-auto'>
      {courseList
        ?.sort((a: any, b: any) => a?.comingSoon - b?.comingSoon)
        ?.map((course, index) => (
          <div
            key={index}
            className='flex flex-col border border-brand-primary-border rounded-xl sm:pb-5 pb-3 bg-brand-third relative overflow-hidden hover:scale-105 transition-all duration-300 ease-in-out'
          >
            {renderText(course)}

            {course?.comingSoon && (
              <div className='-ml-2 w-[104%] max-sm:mt-6 max-sm:mb-2'>
                <GlowRibbon />
                {/* <AnimatedGradientText className='!max-w-5xl w-[250px] !h-10 rounded-none -mt-2 -mr-24'>
                <>
                  🎉 <hr className='mx-2 h-4 w-px shrink-0 bg-gray-300' />{' '}
                  <span
                    className={cn(
                      `inline animate-gradient bg-gradient-to-r from-[#ffaa40] via-[#9c40ff] to-[#ffaa40] bg-[length:var(--bg-size)_100%] bg-clip-text text-transparent`
                    )}
                  >
                    Coming Soon!
                  </span>
                </>
              </AnimatedGradientText> */}
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

function renderText(course: Course) {
  if (!course?.comingSoon)
    return (
      <>
        <DMLink href={`/courses/${course?.slug}`} className='flex flex-col flex-1'>
          <div className='h-[220px] overflow-hidden'>
            <R2Image
              fileName={course.thumbnailImage as string}
              width={390}
              height={220}
              className='w-full h-full object-cover hover:scale-105 transition-all duration-300 ease-in-out'
            />
          </div>
          <div className='relative flex flex-col mt-5 px-4 flex-1'>
            <div className='flex justify-between items-start mb-1 sm:mb-3'>
              <h4 className='leading-7 max-sm:text-lg'>{course.title}</h4>
              <span className='badge absolute right-[15px] top-[-50px]'>
                {convertSecondsToMinOrHours(course.duration || 0, 'short')}
              </span>
            </div>
            <p className='sub-description flex-1 max-sm:text-xs !line-clamp-3'>
              {course.description}
            </p>
          </div>
        </DMLink>
        <div className='relative mt-4 bottom-0 flex items-center justify-between px-4'>
          <div className='flex items-baseline gap-2 justify-start'>
            <h4 className='font-bold'>₹{course.offerPrice || course?.price} </h4>
            <div className='flex gap-1 items-center'>
              {!!course?.discountPercentage && (
                <h4 className='text-sm line-through text-gray-400 max-sm:text-xs'>
                  ₹{course?.price}
                </h4>
              )}
              {!!course?.discountPercentage && (
                <p className='text-brand-primary text-xs'>
                  {Math.ceil(course?.discountPercentage || 0)}% off
                </p>
              )}
            </div>
          </div>
          <CoinAndLevelUp coin={course.coin} points={course.point} />
        </div>
      </>
    );

  return (
    <div className='flex flex-col flex-1'>
      <div className='h-[220px] relative'>
        <div className='absolute inset-0 bg-opacity-60 flex items-center justify-center' />

        <R2Image
          fileName={course.thumbnailImage}
          width={390}
          height={220}
          className='w-full h-full object-cover'
        />
      </div>
      <div className='relative flex flex-col mt-5 px-4 flex-1'>
        <div className='flex justify-between items-start mb-1 sm:mb-3'>
          <h4 className='leading-7 max-sm:text-lg'>{course.title}</h4>
        </div>
        <p className='sub-description flex-1 max-sm:text-xs !line-clamp-3'>{course.description}</p>
      </div>
    </div>
  );
}
